import { Component, OnInit,Input } from '@angular/core';
import { OmsServiceService } from '../../services/oms-service.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'; 

@Component({
  selector: 'app-track-reimbursement',
  templateUrl: './track-reimbursement.component.html',
  styleUrls: ['./track-reimbursement.component.scss']
})

export class TrackReimbursementComponent implements OnInit {

  @Input() order_id;
  @Input() claim_id;
  reimburseDetailsRes=[]
  reimburseStatusList:any=[] 

  statuslist={
    '1':'New',
    '2':'Assigned',
    '3':'In review',
    '4':'Rejected',
    '5':'Approved',
    '6':'Pending for payment release',
    '7':'Paid'
  }

  constructor(

    private omsService :OmsServiceService,
    public modal: NgbActiveModal,

  ) { }

 

  ngOnInit(): void {
    this.getReimbursementData(this.order_id,this.claim_id)
  }

 

  getReimbursementData(transactionId,claimId){

    let reimburseRequest = {};
    reimburseRequest["transactionId"] = transactionId;
    reimburseRequest["claimId"] = claimId;
    reimburseRequest['tenantCode'] = '1000001';
    reimburseRequest['orgCode'] = '100001';

    this.omsService.getReimburseDetails(reimburseRequest).subscribe(
      (res) => {
        if (res["status"] == 1) {
          this.reimburseDetailsRes = res["data"];
          this.reimburseStatusList=this.reimburseDetailsRes[0].statusList

          console.log(`this.reimburseStatusList`, this.reimburseStatusList,);
          console.log(`this.this.reimburseDetailsRes`, this.reimburseDetailsRes,);
        }      

      }
    )

  }
  
}